module.exports = __webpack_public_path__ + "img/checkbox_minus_purple.127937ca.svg";